export const theme = {
  colors: {
    primary: {
      navy: '#1D3557',
      blue: '#457B9D',
      orange: '#FE7200',
      orangeLight: '#FF8C3A',
    },
    neutral: {
      white: '#FFFFFF',
      gray50: '#F8FAFE',
      gray100: '#F0F0F0',
      gray200: '#E5E5E5',
      gray300: '#D4D4D4',
      gray600: '#6B7280',
      gray800: '#1F2937',
    },
    accent: {
      peach: '#FCD6C7',
      lightBlue: '#F0F8FF',
      lightOrange: '#FFF5F0',
      lightGreen: '#F0FFF4',
    },
    semantic: {
      success: '#1D7D32',
      error: '#DC2626',
      warning: '#F59E0B',
    },
  },
  typography: {
    fontFamily: {
      base: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    },
    fontSize: {
      xs: '12px',
      sm: '14px',
      base: '16px',
      lg: '18px',
      xl: '20px',
      '2xl': '24px',
      '3xl': '30px',
      '4xl': '36px',
      '5xl': '48px',
      '6xl': '60px',
    },
    fontWeight: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      tight: 1.2,
      base: 1.5,
      relaxed: 1.6,
    },
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    '2xl': '48px',
    '3xl': '64px',
    '4xl': '80px',
    '5xl': '120px',
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    '2xl': '20px',
    full: '9999px',
  },
  shadows: {
    sm: '0 1px 2px rgba(0, 0, 0, 0.05)',
    md: '0 4px 12px rgba(0, 0, 0, 0.08)',
    lg: '0 4px 20px rgba(0, 0, 0, 0.08)',
    xl: '0 12px 40px rgba(0, 0, 0, 0.12)',
  },
  transitions: {
    fast: '0.15s ease',
    base: '0.3s ease',
    slow: '0.5s ease',
  },
};

export default theme;